import { useState, useRef, useEffect, useContext } from 'react';
import { useHistory } from "react-router";
import { Button } from "react-bootstrap";
import DatePicker from 'react-datepicker';
import { useForm, Controller } from "react-hook-form";
import Sidebar from '../../../components/Navigation/Sidebar';
import Topbar from '../../../components/Navigation/Topbar';
import Header from '../../../components/Page/header';
import { ConvertToMoney } from '../../../utils/formattingUtils';
import { buttonIcon, buttonTypes } from "../../../utils/buttonsUtil";
import Grid from '../../../components/Grid';
import { connect } from "react-redux";
import ReasonFailedAssignmentModal from "../../../components/Modal/AutomaticAssigmentAlert/ReasonFailedAssignment/index" 

const PendingOrdersAssigners = ({
    addressesToAutomaticAssingment,
    reduxGetAllAddressesToautomaticAssigment,
    reduxDownloadAllAutomaticAssigment,
    reduxResetAllAddressesToautomaticAssigment,
    reduxResetStatusRecordAutomaticAssignment
}) => {
    const {
        handleSubmit,
        control,
        formState: { errors },
        setError,
        reset: resetSearch,
    } = useForm({
        defaultValues: {
            dates: null,
        }
    });

    const formatDate = (date) => {
        if (!date) return '';
        const d = new Date(date);
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const dd = String(d.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    };

    const history = useHistory();
    const searchRef = useRef("");

    const [addresses, setAddresses] = useState({});
    const [showFailedReasonModal, setShowFailedReasonModal] = useState(false);
    const [selectedIdAddress, setSelectedIdAddres] = useState();
    const [offset, setOffset] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [idState, setIdState] = useState(2);
    const [search, setSearch] = useState("");
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [defaultStartDate, setDefaultStartDate] = useState(formatDate(new Date(getThreeDaysAgo())));
    const [defaultEndDate, setDefaultEndDate] = useState(formatDate(new Date()));

    useEffect(() => {
        let filters = {
            from: formatDate(new Date()),
            to: formatDate(new Date()),
            page: currentPage,
            search,
            offset,
            idState
        };

        reduxGetAllAddressesToautomaticAssigment(filters);
    }, [currentPage, offset])

    useEffect(() => {
        return () => {
            reduxResetAllAddressesToautomaticAssigment();
        };
    }, []);

    const actionButtons = [
        {
            onClick: () => history.push("/assigner"),
            description: "Ir al dashboard de asignador automático",
            buttonType: buttonTypes.Primary,
            buttonIcon: buttonIcon.Arrow_LeftReply,
        },
    ];

    const customStyles = {
        PendingOrdersColorCard: {
            background: '#FFC34D',
            background: 'linear-gradient(90deg,rgba(255, 195, 77, 0.76) 58%, rgba(255, 195, 77, 1) 100%)',
        },
        downloadButton: {
            backgroundColor: 'rgba(255, 195, 77, 1)',
            borderColor: 'rgba(255, 195, 77, 1)',
            color: '#fff'
        }
    };

    const columns = [
        {
            title: '#',
            render: (rowData) => {
                return <span>{rowData.idAddress}</span>;
            },
            field: 'idAddress',
            searchable: true,
        },
        {
            title: 'Remitente',
            render: (rowData) => {
                return <span>{rowData.shipperName ? rowData.shipperName : ''}</span>;
            },
            field: 'company.description',
            searchable: true,
        },
        {
            title: 'Valor Declarado',
            render: (rowData) => {
                return <span>{ConvertToMoney(rowData.collection)}</span>;
            }
        },
        {
            title: 'Dirección',
            render: (rowData) => {
                return <span>{rowData.address}</span>;
            },
        },
        {
            title: 'Ciudad destino',
            render: (rowData) => {
                return <span>{rowData.cityNameReceiver ? rowData.cityNameReceiver : ''}</span>;
            },
            field: 'city.description',
            searchable: true,
        },
        {
            title: 'Fecha Creación',
            render: (rowData) => {
                const fecha = rowData.createdAt ? rowData.createdAt.split('T')[0] : '';
                return <span>{fecha}</span>;
            },
        },
        {
            title: 'ID Externo',
            render: (rowData) => {
                return <span>{rowData.externalId}</span>;
            },
            field: 'externalId',
            searchable: true,
        },
        {
            title: 'Operador',
            render: (rowData) => {
                return <span>{rowData.operatorName ? rowData.operatorName : ''}</span>;
            },
            field: 'operator',
            searchable: true,
        }
    ]

    const changeDates = (dates) => {
        const [start, end] = dates;

        setStartDate(start);
        setEndDate(end);
    };

    const searchSubmit = (_e) => {
        if (!startDate || !endDate) {
            let filters = {
                page: currentPage,
                offset,
                search,
                idState,
                from: formatDate(new Date()),
                to: formatDate(new Date()),
            };

            reduxGetAllAddressesToautomaticAssigment(filters);
            return;
        }

        let filters = {
            page: currentPage,
            offset,
            search,
            idState,
            from: formatDate(startDate),
            to: formatDate(endDate),
        };

        reduxGetAllAddressesToautomaticAssigment(filters);
    }

    const handleCloseModal = () => {
        setShowFailedReasonModal(false);
        setSelectedIdAddres(null);
        reduxResetStatusRecordAutomaticAssignment();
    }

    function getThreeDaysAgo () {
        const fiveDaysAgo = new Date();
        fiveDaysAgo.setDate(fiveDaysAgo.getDate() - 3);
        const fiveDaysAgoStr = fiveDaysAgo.toISOString().slice(0, 10);
        return fiveDaysAgoStr;
    }

    return (
        <div id='wrapper'>
            <Sidebar />
            <div id='content-wrapper' className='d-flex flex-column'>
                <div id='content'>
                    <Topbar />
                    <div className="container-fluid">
                        <Header title={"Órdenes pendientes"} actionButtons={actionButtons} />

                        <div className='card shadow mb-4'>
                            <div className='card-header py-3'>
                                <h6 className='m-0 font-weight-bold text-primary'>Listado de Órdenes</h6>
                            </div>

                            <div className='d-flex align-items-center justify-content-end mt-2 mr-4'>
                                {false && (
                                    <div className='d-flex flex-row'>
                                        <div className='form-group mb-0 mt-0 mr-2'>
                                            <label htmlFor='dates' className='form-label text-primary mb-1'>
                                                Desde - Hasta
                                            </label>
                                            <Controller
                                                control={control}
                                                name="dates"
                                                rules={{ required: false }}
                                                render={({ field }) => (
                                                    <>
                                                        <DatePicker
                                                            className={'form-control'}
                                                            startDate={startDate}
                                                            endDate={endDate}
                                                            selectsRange
                                                            onChange={(value) => {
                                                                field.onChange(value);
                                                                changeDates(value);
                                                            }}
                                                            dateFormat="yyyy-MM-dd"
                                                            minDate={new Date(getThreeDaysAgo())}
                                                            maxDate={new Date()}
                                                            shouldCloseOnSelect={false}
                                                            isClearable
                                                        />
                                                        {errors.dates && (
                                                            <span className="text-danger" style={{ fontSize: '0.85em' }}>
                                                                {errors.dates.message}
                                                            </span>
                                                        )}
                                                    </>
                                                )}
                                            />
                                        </div>
                                        <div className='form-group mt-4'>
                                            <Button
                                                variant='primary'
                                                type='submit'
                                                id='btnSearch'
                                                style={{ position: 'relative', top: '0.25rem' }}
                                                onClick={handleSubmit(searchSubmit)}
                                            >
                                                Buscar
                                            </Button>
                                        </div>
                                    </div>
                                )}

                                <div className='d-flex flex-row mr-0'>
                                    <div className='card shadow mb-0' style={customStyles.PendingOrdersColorCard}>
                                        <div className='mx-3 pt-1 pb-2'>
                                            <div className='row no-gutters align-items-center'>
                                                <div className='col mr-2'>
                                                    <div className='text-xs font-weight-bold text-uppercase text-white'>
                                                        Órdenes pendientes hoy:
                                                    </div>
                                                </div>
                                                <div className='h5 mb-0 font-weight-bold text-white'>
                                                    {addressesToAutomaticAssingment && addressesToAutomaticAssingment.hasOwnProperty('total') ? addressesToAutomaticAssingment.total : 0}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <button
                                        title='Descargar lista de órdenes pendientes'
                                        className='btn ml-1'
                                        type='button'
                                        style={customStyles.downloadButton}
                                        onClick={() => reduxDownloadAllAutomaticAssigment({
                                            idState: 2,
                                            search: searchRef.current,
                                            from: formatDate(new Date()),
                                            to: formatDate(new Date()),
                                        })}>
                                        <i className='fas fa-file-download fa-sm'></i>
                                    </button>
                                </div>
                            </div>

                            <div className='card-body'>
                                <Grid
                                    className='stickyAddress'
                                    cols={columns}
                                    data={addressesToAutomaticAssingment && Object.keys(addressesToAutomaticAssingment).length > 0 ? addressesToAutomaticAssingment.items : []}
                                    total={addressesToAutomaticAssingment && addressesToAutomaticAssingment.hasOwnProperty('total') ? addressesToAutomaticAssingment.total : 0}
                                    page={addressesToAutomaticAssingment && Object.keys(addressesToAutomaticAssingment).length > 0 ? Number(addressesToAutomaticAssingment.page) : currentPage}
                                    pages={addressesToAutomaticAssingment && Object.keys(addressesToAutomaticAssingment).length > 0 ? Number(addressesToAutomaticAssingment.totalPages) : 0}
                                    offset={offset}
                                    onChangePage={(page) => setCurrentPage(page)}
                                    onChangeRange={(value) => {
                                        setOffset(value);
                                        setCurrentPage(1);
                                    }}
                                    onChangeSearch={(value) => {
                                        setSearch(value)
                                        searchRef.current = value;

                                        const filters = {
                                            page: currentPage,
                                            offset,
                                            search: value,
                                            idState,
                                            from: formatDate(new Date()),
                                            to: formatDate(new Date()),
                                        }

                                        reduxGetAllAddressesToautomaticAssigment(filters);
                                    }}
                                >
                                </Grid>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ReasonFailedAssignmentModal 
                selectedIdAddress = {selectedIdAddress}
                showFailedReason = {showFailedReasonModal}
                handleCloseModal = {handleCloseModal}
            >
            </ReasonFailedAssignmentModal>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        addressesToAutomaticAssingment: state.addressToAutomaticAssigmentState.addressesToAutomaticAssingment,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        reduxGetAllAddressesToautomaticAssigment: (payload) =>
            dispatch({
                type: "GetAllAddressesToAutomaticAssigment",
                value: payload,
            }),
        reduxDownloadAllAutomaticAssigment: (payload) =>
            dispatch({
                type: "DownloadAllAutomaticAssigment",
                value: payload,
            }),
        reduxResetAllAddressesToautomaticAssigment: () =>
            dispatch({ type: "RESET_ALL_ADDRESSES_TO_AUTOMATIC_ASSIGMENT" }),
        reduxResetStatusRecordAutomaticAssignment: () => 
            dispatch({ type: "RESET_STATUS_RECORD_AUTOMATIC_ASSIGNMENT" }),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PendingOrdersAssigners);